export function hasAnswer(question, value) {
  if (question.type === "multi") return Array.isArray(value) && value.length > 0;
  return value !== null && value !== undefined && String(value).trim() !== "";
}
export function answerSignature(questions, answers) {
  return JSON.stringify(questions.map(q => [q.id, answers[q.id] ?? null]));
}
export function parseAnswers(value, questionnaireId, questions) {
  try {
    const data = typeof value === "string" ? JSON.parse(value) : value;
    if (!data || (data.questionnaireId && data.questionnaireId !== questionnaireId) || !data.answers || Array.isArray(data.answers)) return null;
    const answers = {};
    for (const q of questions) {
      const value = data.answers[q.id];
      if (value === undefined || value === null) continue;
      if (q.type === "multi") {
        if (!Array.isArray(value) || value.some(v => typeof v !== "string")) return null;
        answers[q.id] = value.filter(v => q.options.includes(v));
      } else if (q.type === "number") {
        if (typeof value !== "number" || !Number.isFinite(value)) return null;
        answers[q.id] = value;
      } else {
        if (typeof value !== "string") return null;
        if (q.type !== "single" || q.options.includes(value)) answers[q.id] = value;
      }
    }
    return answers;
  } catch { return null; }
}
